var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table-golden',{attrs:{"items":_vm.itemsPublic,"headers":_vm.headersPublic,"is-mobile":_vm.isMobile}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }